import { Component, Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ProveedoresService } from '../../../service/proveedores/proveedores.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ErrorDialogComponent } from '../../error-dialog/error-dialog.component';
import { CambiarEstatusDialogComponent } from '../../cambiar-estatus-dialog/cambiar-estatus-dialog.component';


@Component({
  selector: 'app-aprobar-compra-dialog',
  templateUrl: './aprobar-compra-dialog.component.html',
  styleUrl: './aprobar-compra-dialog.component.scss'
})
export class AprobarCompraDialogComponent {

  headerTitle = 'Datos de Solicitud de Compra'

  constructor( 
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) 
    public data: any, 
    public dialogRef: MatDialogRef<AprobarCompraDialogComponent>) {
      
  }

  ngOnInit() {

  }

  closeDialog(){
    this.dialogRef.close({event: 2})
  }
}
